import React, { useEffect, useState } from "react";
import SellerProjectCard from "../../atoms/SellerProjectCard";
import { getUsersList } from "../../../utils/API/getUsersList";
import { useSearchParams } from "react-router-dom";
import Pagination from "../../atoms/Pagination";
import ProjectListLoader from "../../atoms/ProjectListLoader";
import Button from "../../atoms/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserName } from "../../../utils/helper/getUserName";

const UserListing = ({ type, user_type, searchItem, filterData }) => {
  const [usersData, setUsersData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPage = Number(searchParams.get("page")) || 1;
  const [noDataFound, setNoDataFound] = useState(false);

  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  });

  const pageSize = 10;

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await getUsersList(
        {
          searchQuery: searchItem,
          // user_type: user_type,
          // status: type,
          user_type: filterData?.user_type,
          status: filterData?.type,
          currentPage: currentPage,
          pagelimit: pageSize
        },
        dispatch
      );
      const data = response.data;
      if (data) {
        setUsersData(data);
        let nextPage = data.length === pageSize;
        let totalItems = nextPage
          ? pageSize * (currentPage + 1)
          : pageSize * (currentPage - 1) + data.length;
        setPagination({
          totalItems: totalItems,
          totalPages: nextPage ? currentPage + 1 : currentPage
        });
      }
      if (data == []) {
        setNoDataFound(true);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [
    currentPage,
    pagination.pageSize,
    searchItem,
    // user_type, type,
    filterData
  ]);

  return (
    <>
      <div>
        {loading ? (
          <ProjectListLoader />
        ) : noDataFound ? (
          <div className="text-center py-10 text-3xl font-semibold text-blue-800">
            {" "}
            Sorry, no results found. Please try adjusting your search criteria
          </div>
        ) : (
          usersData.map((user, index) => (
            <SellerProjectCard
              key={index}
              userId={user._id}
              userTitle={UserName(user.name, 30)}
              userType={user.user_type}
              userLocation={user.location}
              TransactionDone={user.no_of_transactions_completed}
              percentage={user.authenticity}
            />
          ))
        )}
      </div>
      <div className="flex gap-4 mb-6">
        <Pagination
          current={currentPage}
          total={pagination.totalItems}
          pageSize={pageSize}
          setCurrentPage={(page) => setSearchParams({ page })}
        />
        <Button
          onClick={() => {
            navigate("/all-users");
          }}
          varient="primary"
          borderColor="blue"
          className="px-10 w-36 font-bold py-2 text-sm text-white bg-blue-800"
        >
          See All
        </Button>
      </div>
    </>
  );
};

export default UserListing;
